import io from 'socket.io-client';

// [CORREÇÃO CRÍTICA] Para o App Android, o IP DEVE SER FIXO.
// O código antigo usava 'window.location', que no celular é 'localhost' (errado).
// [CORREÇÃO CRÍTICA] Para o App Android, o IP DEVE SER FIXO.
// O código antigo usava 'window.location', que no celular é 'localhost' (errado).
const SOCKET_URL = 'https://wadesk.com.br';

console.log('[Socket] Conectando em:', SOCKET_URL);

export const socket = io(SOCKET_URL, {
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    transports: ['polling', 'websocket'],  // Polling primeiro (funciona com IIS/proxy), depois tenta upgrade para WS
    upgrade: true,                          // Permite upgrade para WebSocket após conectar por polling
    forceNew: true,
    path: '/socket.io',
});

export const connectSocket = () => {
    if (!socket.connected) {
        console.log('[Socket] Forçando conexão...');
        socket.connect();
    }
};

export const disconnectSocket = () => {
    if (socket.connected) {
        socket.disconnect();
    }
};